import Http from '../api/http/';
export default class platformUser extends Http {
  constructor() {
    super();
  }

  //获取平台用户数据
  platUser_getUser2PPage() {
    return super.post('platUser/getUser2PPage', ...arguments);
  }

  //创建平台用户
  platUser_create2P() {
    return super.post('platUser/create2P', ...arguments);
  }

  // 修改平台用户
  platUser_update2PUserNameAndRole() {
    return super.post('platUser/update2PUserNameAndRole', ...arguments);
  }

  // 登出
  platUser_logout() {
    return super.post('platUser/logout', ...arguments);
  }
  /**
   * 获取成本中心列表
   *
   */
  platUser_getCostCenterList() {
    return super.post('platUser/getCostCenterList', ...arguments);
  }

  /**
   * 获取平台账号
   * @param {Object} params
   * @param {number} params.isContainForbid 是否包含禁用账号（1-包含）
   * @returns {Promise<Array<{ids: string, names: string}>>} 平台账号列表（ids-用户id，names-用户名称）
   */
  platUser_getAllPlatUserList() {
    return super.post('platUser/getAllPlatUserList', ...arguments);
  }
}
